// This stores the callback functions
const callbacks = {};
/**
 * Add the api functions to the window object.
 */
export function setup() {
    window.kb = {
        on: (event, cb) => {
            registerCallback(event, cb);
        },
    };
}
function assertUnreachable(event) {
    const msg = `window.on: ${event} is not a supported event type.`;
    console.warn(msg);
    throw new Error(msg);
}
export function registerCallback(event, cb) {
    const _event = event;
    switch (_event) {
        case 'page:change': {
            callbacks[event] = cb;
            return;
        }
        case 'article:load': {
            callbacks[event] = cb;
            return;
        }
        default: {
            assertUnreachable(_event);
        }
    }
}
export function triggerCallback(event, data) {
    const cb = callbacks[event];
    if (typeof cb === 'function') {
        // TS is complaining about this, not sure why...
        cb(data);
    }
}
//# sourceMappingURL=clientApi.js.map